module.exports = __webpack_public_path__ + "img/blue-hair-doc-female.2405c8e1.png";